import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
import 'firebase/firestore';
@Component({
  selector: 'app-seccion-misactividades',
  templateUrl: './seccion-misactividades.component.html',
  styleUrls: ['./seccion-misactividades.component.css']
})
export class SeccionMisactividadesComponent implements OnInit {
  actividades: Observable<any[]>;
  constructor(private servicio:ServicioFirebaseService) {}

  ngOnInit() {
    this.cargarInformacion();
  }
  ponertarjer(){
    this.servicio.afAuth.authState.subscribe(res=>{
      if(res){
        this.servicio.poner(res.uid);
      }
      //servicio.asignarActividades(res.uid);
    });
  }
  eliminarActividad(act){
    this.servicio.eliminarTarea(act);
  }
  cargarInformacion(){
    this.servicio.afAuth.authState.subscribe(res=>{
      if(res){
        this.actividades=this.servicio.asignarActividades(res.uid);
      }
      //servicio.asignarActividades(res.uid);
    });
  }

}
